import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X, FileText } from 'lucide-react';
import { PdfViewer } from './PdfViewer';

// Modal de PDF em tela cheia (portal no body, acima de headers fixos). Esc fecha.
export const PdfViewerModal = ({ open, onClose, src, filename, title, labels, closeLabel = 'Close', testId = 'pdf-modal' }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow; document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [open, onClose]);

  return createPortal(
    <AnimatePresence>
      {open && src && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[100] bg-slate-950/90 flex flex-col" data-testid={testId}>
          <div className="flex items-center justify-between gap-3 px-3 py-2 text-white shrink-0" style={{ paddingTop: 'calc(0.5rem + env(safe-area-inset-top))' }}>
            <div className="flex items-center gap-2 min-w-0">
              <FileText className="h-5 w-5 shrink-0 text-teal-300" />
              <div className="min-w-0"><p className="text-sm font-bold truncate" data-testid={`${testId}-title`}>{title || filename}</p>{title && filename && <p className="text-[11px] text-white/60 truncate">{filename}</p>}</div>
            </div>
            <button type="button" onClick={onClose} className="h-10 w-10 rounded-full bg-white text-slate-900 flex items-center justify-center shadow-lg hover:scale-105 transition-transform shrink-0" aria-label={closeLabel} data-testid={`${testId}-close`}><X className="h-5 w-5" /></button>
          </div>
          <div className="flex-1 min-h-0 mx-auto w-full max-w-5xl px-0 sm:px-3 pb-0 sm:pb-3">
            <motion.div initial={{ y: 16, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="h-full rounded-t-2xl sm:rounded-2xl overflow-hidden bg-white shadow-2xl flex flex-col">
              <PdfViewer src={src} filename={filename} labels={labels} className="h-full" />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body,
  );
};
